module.exports = {
	"home": {
		"p1": "In defense of fair trade",
		"p2": "and competition on equal terms"
	},
	"nosotros": {
		"title": "About us",
		"consultig": {
			"title": "T-REZ Consulting",
			"p": " starts in 2018 as a new firm, but with an experience of their professionals of more than 25 years in trade remedies and international trade dispute settlements. "
		},
		"trez1": {
			"title": "T-REZ",
			"p": " is the only firm in Mexico specialized in Trade Remedies and International Trade Dispute Settlements, particularly in the defense of domestic industries against unfair trade practices and also in defending national producers affected by antidumping and countervailing duties. "
		},
		"trez2": {
			"title": "T-REZ",
			"p": " offers legal services and economic analysis in Trade Remedies, Dispute Settlements, International Trade and Economic Analysis for trade lawsuits, highly specialized and unique in the market. "
		}
	},
	"socias": {
		"title": "partners",
		"nombres": {
			"luz": "Luz Elena Reyes de la Torre",
			"itzia": "Itziar Esparza Mejía",
			"barbara": "Bárbara Casiopea Alvarado Ibarra"
		},
		"Luz": {
			"title": "Luz Elena Reyes de la Torre",
			"p1": "Founding Partner.",
			"p2": "More than 25 years of experience in Trade Remedies and Dispute Settlements, mainly on antidumping, subsidies and safeguards proceedings. ",
			"p3": "Partner at SAI Law & Economics for 20 years.",
			"p4": "Deputy Director General at the Unit of International Trade Practices of Mexico where she participated in the design of the Mexican Antidumping System.",
			"p5": "She has provided technical advisory services  to Latin American governments regarding the implementation and application of the Antidumping Agreement, the Safeguards Agreement and the Subsidies and Countervailing Measures Agreement.",
			"p6": "Member of the Consultative Council of International Trade Practices.",
			"p7": "Mexican Panelist with more participations in trade dispute settlement panels at the WTO.",
			"p8": "In April of 2016 she was appointed Member of the WTO Permanent Group of Experts in Subsidies and Countervailing Measures for the 2016-2021 period."
		},
		"Itziar": {
			"title": "Itziar Esparza Mejía",
			"p1": "Founding Partner.",
			"p2": "She has more than a decade of professional experience in trade remedies (antidumping, subsidies and safeguards investigations) and dispute trade settlements (trade and investment arbitration).",
			"p3": "She has specialized in representing domestic industries such as animal food, household goods, textiles, footwear, agricultural products and the iron and steel industry, including review proceedings of antidumping determinations on binational panels under Chapter XIX of the North American Free Trade Agreement and World Trade Organization, and annulment trials before the Federal Tribunal of Fiscal and Administrative Justice.",
			"p4": "Before specializing on Trade Remedies, she had six years of experience on international trade arbitration under the CCI, LCIA, AAA, CAM, NAI rules and investment arbitration under Chapter XI of the NAFTA, assisting arbitration tribunals and as party counsel.",
			"p5": "She has also represented companies in immunity proceedings and competition investigations before the Mexican Federal Economic Competition Commission, including investigations regarding the telecommunication and consumer goods markets."
		},
		"barbara": {
			"title": "Bárbara Casiopea Alvarado Ibarra",
			"p1": "Partner.",
			"p2": "Bárbara has more than 20 years of experience in trade remedies practice. She worked for 23 years in the Ministry of Economy, where she served for 10 years as General Adjoint Director of Legal Affairs of the International Trade Practices Unit, in charge of supervising and coordinating the dumping, subsidies and safeguards investigations conducted by the Mexican authority, pertaining to sectors such as steel, textiles, footwear, agriculture, chemicals and other manufactured goods;; she  participated in more than 200 investigations.",
			"p3": "Furthermore, she has experience in domestic litigation, since she was in charge for more than 20 years of resolving administrative appeals (recursos de revocación) submitted against trade remedies final determinations. She also lead the defense strategy in amparo trials and administrative litigation proceedings.",
			"p4": "She has participated in the reform of several foreign trade laws and regulations, such as the Foreign Trade Law and the Customs Law and, more recently, she coordinated the latest amendments to the Regulations of the Foreign Trade Law.",
			"p5": "In the academic field, she has taught several courses on foreign trade and training on trade remedies, both to national and foreign authorities.",
			"p6": "Bárbara has a law degree from the National Autonomous University of Mexico, a Master in Law and a specialty in Constitutional Law, from the same institution."
		}
	},
	"profesionales": {
		"main": "profesionales",
		"title": "Luz Elena Reyes de la Torre",
		"p1": "Founding Partner.",
		"p2": "• Más de 25 años de experiencia en materia de Remedios Comerciales y controversias comerciales internacionales, principalmente sobre antidumping, subsidios y salvaguardas.",
		"p3": "• Fue Socia en SAI Derecho & Economía durante 20 años.",
		"p4": "• Fue Directora General Adjunta de la Unidad de Prácticas Comerciales Internacionales de México en donde participó en el diseño del Sistema Antidumping Mexicano.",
		"p5": "• Es la Panelista de nacionalidad mexicana con más participaciones en paneles de solución de controversias comerciales en la OMC.",
		"p6": "• Ha prestado servicios de asistencia técnica sobre la implementación y aplicación de los Acuerdos Antidumping, de Salvaguardas y sobre el Acuerdo de Subvenciones y Medidas Compensatorias a los gobiernos de América Latina.",
		"p7": "• Es miembro del Consejo Consultivo de Prácticas Comerciales Internacionales.",
		"p8": "• En abril de 2016 fue nombrada Miembro del Grupo Permanente de Expertos de la OMC en materia de Subvenciones y Derechos Compensatorios por el periodo 2016-2021.",
		"url": ""
	},
	"servicios": {
		"title": "Services",
		"t1": "Trade Remedies",
		"t2": "Trade Disputes",
		"t3": "Antidumping Litigation",
		"t4": "Economic Litigation Consulting",
		"t5": "Strategic Monitoring",
		"t6": "Mx-USA Trade Planning",
		"p1": "T-REZ Consulting (T-REZ) is a firm specialized in “Trade Remedies” and International Dispute Settlements.",
		"p2": "We offer to domestic producers our specialized knowledge in international law and economics to advise them in all the stages of the several procedures against dumping practices or against unfair international competition by subsidies and financial support by governments, and also assist them in international dispute settlements.",
		"p3": "T-REZ services include a wide variety of services regarding trade remedies and international dispute settlements mechanisms:",
		"p4": "- Feasibility studies to determine if a case of alleged unfair trade practices has a high probability of success, in which case we prepare the legal and economic analysis to integrate a petition of antidumping investigation, subsidies or safeguard measures investigation and sunset reviews, circumvention and scope proceedings.",
		"p5": "- Once a formal petition is submitted to the Secretariat of Economy, T-REZ oversees the legal representation of domestic producers in the proceedings before the investigating authority or, when necessary, in annulment trails.",
		"p6": "-T-REZ advises Governments or domestic producers in bilateral trade panels or WTO panels.",
		"p7": "-It also advises exporters to the US market in antidumping investigations and offers preventive advisory for a successful defense against possible investigations.",
		"p8": "In sum, T-REZ team has more than 20 years of experience in the defense of domestic industries against international unfair trade practices, offering  integral  legal and economic services to the industry. Furthermore, T-REZ offers advice and representation of parties in the defense of trade dispute settlement mechanisms, both under NAFTA and WTO legislation. "
	},
	"remedios": {
		"title": "TRADE REMEDIES",
		"antidumping": {
			"h1": "Antidumping",
			"p1": "T-REZ specializes in defending domestic industries in trade remedies proceedings  against unfair trade practices.",
			"p2": "T-REZ elaborates feasibility studies in order to asses the potential merits of a case with a methodology pursuant to national and international legislation, and the success probabilities (i.e., the imposition of definitive antidumping duties against unfair imports). ",
			"p3": "T-REZ represents domestic industries throughout the legal proceedings and elaborates all the economic studies and legal documentation necessary to defend their interests."
		},
		"subvenciones": {
			"h1": "ANTI-SUBSIDIES",
			"p1": "One of our founding partners is Member of the WTO Permanent Group of Experts in Subsidies and Countervailing Measures; at domestic level, she represented the Mexican industry in one of the few anti-subsidies cases in Mexico, specifically against agricultural subsidies granted to Spain and Italy by the European Commission.",
			"p2": "T-REZ analyzes the existence of subsidies, also if those are countervailable and, if it is the case, it elaborates the economic and legal documentation to defend and represent the domestic industry in the instant investigation. "
		},
		"salvaguardias": {
			"h1": "SAFEGUARDS",
			"p1": "When there is a significant increase on imports that cause or threaten to cause serious injury to the Mexican industry, despite the absence of unfair practices, T-REZ elaborates the necessary analysis and arguments to request the application of safeguard measures, being a temporary increase of tariffs or a quantitative restriction on imports, in order to allow the domestic industry to start an adjustment program to improve their competitiveness.",
			"p2": "The combined experience of the founding partners includes leading the studies and representing the domestic poultry industry in the only bilateral safeguard under NAFTA carried out in Mexico, which concluded with a successful negotiation among the industries of the two countries (USA and Mexico) and with measures applied for 5 years."
		},
		"examenes": {
			"h1": "SUNSET REVIEWS",
			"p1": "Previous to the expiration of an antidumping duty or a countervailing measure, within five years of its imposition, there exist a legal procedure by which such duties can be extended for five additional years to the extent legal requirements are met, referred to as sunset review.  ",
			"p2": "Our founding partners have successfully represented several domestic industries in sunset reviews."
		},
		"reviciones": {
			"h1": "ANNUAL REVIEWS",
			"p1": "T-REZ represents domestic industries in cases in which an exporter request the review of its dumping margin after the imposition of the antidumping duties based on a period more recent than the original period of investigation, seeking to reduce or eliminate their antidumping duties; in such cases it is extremely important that the domestic industry participates and ensures that the adequate procedures are followed and that the pertinent methodologies are applied in order to avoid any unjustified reduction or elimination of antidumping duties. T-REZ is responsible of this defense representing the domestic industry."
		},
		"elusion": {
			"h1": "ANTI-CIRCUMVENTION ",
			"p1": "In many occasions importers or exporters try to avoid (circumvent) the payment of antidumping duties or countervailing measures, slightly differentiating the product that was subject to investigation or importing the product in different parts when it is possible. T-REZ represents domestic producers in anti-circumvention procedures to counteract such unjustified practices and to enforce the antidumping duty in those products."
		},
		"cobertura": {
			"h1": " COVERAGE OF INVESTIGATED PRODUCT",
			"p1": "When an importer or exporter of a product subject to antidumping duties or countervailing measures starts a procedure requesting the investigating authority to exclude certain products from the scope of the measure, T-REZ advises domestic producers to ensure that the investigating authority does not exclude from the application of antidumping duties or countervailing measures any product that must be considered within the definition of investigated product, according to the procedure and the facts that were demonstrated during the original investigation to apply those duties. "
		}
	},
	"disputas": {
		"title": "Trade Disputes",
		"panelesTLC": {
			"h1": "NAFTA-USMCA PANELS",
			"p1": "T-REZ offers representation of parties in Binational Panels under USMCA (previously NAFTA), in favor of final determinations imposing antidumping duties that have been challenged by exporters."
		},
		"panelesOMC": {
			"h1": "WTO PANELS",
			"p1": "We offer professional services to advice governments in the defense of their final determinations before Panels and Appellate Body under the WTO Dispute Settlement Body. The services include preparing their written submissions and appearances before the Panel and/or Appellate Body and provide legal support with relevant precedents for their defense."
		}
	},
	"litigios": {
		"title": "ANTIDUMPING LITIGATION",
		"recursos": {
			"h1": "REVOCATION REMEDY",
			"p1": "T-REZ represents companies in challenge proceedings before the Secretariat of Economy (revocation remedy) against final determinations of antidumping and countervailing duties investigations, sunset reviews or any other trade remedies proceedings under the Foreign Trade Law."
		},
		"juicios": {
			"h1": "ANNULMENT TRIAL",
			"p1": "T-REZ represents companies in annulment trials before the Federal Tribunal of Fiscal and Administrative Justice against final antidumping determinations."
		},
		"amparos": {
			"h1": "AMPARO",
			"p1": "T-REZ collaborates with law firms in amparo trials related to trade remedies final determinations issued by the Secretariat of Economy."
		},
		"peritajes": {
			"h1": "EXPERT OPINIONS",
			"p1": "T-REZ offers legal and economic expert opinions, required in trade remedies proceedings and annulment trials."
		}
	},
	"economia": {
		"title": "ECONOMIC LITIGATION CONSULTING",
		"menu": {
			"p1": "IMPORTS ANALYSIS",
			"p2": "DUMPING MARGIN",
			"p3": "INJURY TO THE INDUSTRY",
			"p4": "SUBSIDIES CALCULATION",
			"p5": "“IN SITU” VERIFICATIONS"
		},
		"analisis": {
			"h1": "IMPORTS ANALYSIS",
			"p1": "In all trade remedies proceedings it is necessary an specific and specialized analysis of international trade transactions; T-REZ offers the elaboration of imports analysis by specific product, by country and by importer in order to identify price patterns to support trade remedies investigations, or to identify price and products trends of main international competitors in the domestic industry."
		},
		"margenes": {
			"h1": "",
			"p1": "T-REZ offers the price analysis of main export products to Mexico in their domestic and export markets, to calculate dumping margins that support an investigation against international unfair trade practices."
		},
		"dano": {
			"h1": "INJURY TO THE INDUSTRY",
			"p1": "T-REZ has specialized professionals to elaborate the necessary studies for the determination of the existence or not of injury or threat of injury caused to domestic industry by unfair competition (dumping or subsidies), according with the national and international accepted methodology."
		},
		"calculo": {
			"h1": "SUBSIDIES CALCULATION",
			"p1": "When a domestic industry considers that an international competitor  illegally benefits from financial supports granted by their government to unfairly gain the domestic market, it is necessary to conduct a  study to determine if those supports exist and if they are effectively affecting their export prices to a country; T-REZ prepares these specialized studies with the methodology accepted by the World Trade Organization and, in appropriate cases, could advise in a petition for the elimination of the subsidy through stablished procedures under national and international legislation."
		},
		"verificacion": {
			"h1": "“IN SITU” VERIFICATIONS",
			"p1": "When domestic exporting companies are notified by competent antidumping authorities, mainly of the USA, about a verification visit in their facilities regarding the information submitted in an ongoing antidumping investigation, T-REZ offers professional and specialized economic, financial, accounting and legal assistance to the company. T-REZ also trains companies’ internal teams, in coordination with US law firms, and assist them with the preparation of all the documentation to be verified by the investigating authority."
		}
	},
	"monitoreos": {
		"title": "STRATEGIC MONITORING",
		"menu": {
			"p1": "PRICES MONITORING",
			"p2": "DUMPING ALERTS"
		},
		"monitoreo": {
			"h1": "PRICES MONITORING",
			"p1": "T-REZ offers the Strategic Trade Monitoring service, which consists in preparing a bimonthly or quarterly analysis report of the prices and import volumes behavior in the Mexican market of specific products of the domestic industry’s main competitors.",
			"p2": "This monitoring allows companies to anticipate possible conditions of the international competition that could affect the domestic industry and it is also useful to know the positioning of international competitors in the domestic market."
		},
		"alertas": {
			"h1": "DUMPING ALERTS",
			"p1": "T-REZ services of “Dumping Alerts” is based on a model that considers several parameters obtained from an analysis of the most relevant economic indicators of the market studied, to determine the possible occurrence of international unfair trade practices in a specific market in an anticipated or preventive manner."
		}
	},
	"tradepla": {
		"title": "MX-USA Trade Planning",
		"menu": {
			"p1": "ANTIDUMPING RISK IN THE USA",
			"p2": "DOC AND ITC QUESTIONNAIRES",
			"p3": "USDOC “IN SITU” VERIFICATIONS"
		},
		"riesgo": {
			"h1": "ANTIDUMPING RISK IN THE USA",
			"p1": "Companies with important presence of their exports in the North American market have the potential risk of an antidumping or countervailing duty investigation initiated by the US government. These investigations could conclude in an antidumping duty or countervailing measures to their exports, affecting their access to that market. ",
			"p2": "T-REZ offers a specialized service, using the methodology applicable in the US, to analyze the conditions of the exports of a domestic company to the US and if there is risks that these exports may be investigated by the US government. It is a preventive service and includes the proposal of changes in the price and sales policies to reduce the risk of antidumping investigations in the US."
		},
		"cuestionarios": {
			"h1": "DOC AND ITC QUESTIONNAIRES",
			"p1": "If an exporter is investigated by the US government for alleged dumping, T-REZ offers the support service to the export company for the adequate filling of antidumping questionnaires requested by the US Department of Commerce, in coordination with US law firms."
		},
		"verificaciones": {
			"h1": "USDOC “IN SITU” VERIFICATIONS",
			"p1": "T-REZ offers professional and specialized services in verification visits regarding economic, financial, accounting and legal aspects. T-REZ also trains companies’ internal teams, in coordination with US law firms, advises them for the preparation of all the documentation to be verified by the US Department of Commerce (USDOC)."
		}
	},
	"industrias": {
		"title": "Industries",
		"menu": {
			"p1": "AGRICULTURAL",
			"p2": "MANUFACTURING",
			"p3": "CONSUMER GOODS"
		},
		"agropecuario": {
			"h1": "AGRICULTURAL",
			"p1": "The combined experience of the founding partners comprises the successful representation of the domestic poultry industry in several proceedings regarding trade remedies and international dispute settlement litigations, including the first and sole safeguard measure applied in Mexico, in a case against chicken leg quarters and thigh imports from the USA in dumping conditions, and defending the domestic poultry industry interests in a bilateral panel under Chapter XIX of NAFTA.",
			"p2": "The founding partners’ expertise includes the representation of olive and olive oil domestic producers against subsidies granted by the European Commission to Spanish and Italian exporters."
		},
		"manufacturero": {
			"h1": "MANUFACTURING",
			"p1": "T-REZ also has a wide experience in several key industries, such as aluminum, stainless steel, copper tube, textiles, ferroalloys, among others."
		},
		"consumo": {
			"h1": "CONSUMER GOODS",
			"p1": "T-REZ experience on consumer goods industries is extensive as well, representing and elaborating studies to support proceedings regarding trade remedies for the kitchen articles, blenders, footwear, clothing and metallic balloons industries."
		}
	},
	"presencia": {
		"title": "V. Presencia",
		"menu": {
			"p1": "• Redes sociales",
			"p2": "• Artículos",
			"p3": "• Noticias"
		},
		"redes": {
			"h1": "• Redes sociales",
			"p1": ""
		},
		"articulos": {
			"h1": "• Artículos",
			"p1": ""
		},
		"noticias": {
			"h1": "• Noticias",
			"p1": ""
		}
	},
	"recursos": {
		"title": "Resources",
		"menu": {
			"p1": "WTO LEGISLATION",
			"p2": "ANTIDUMPING IN MEXICO",
			"p3": "ANTIDUMPING IN THE US",
			"p4": "TRADE STATISTICS",
			"p5": "OTHER RELEVANT SITES"
		},
		"legislacion": {
			"h1": "WTO LEGISLATION",
			"p1": "Antidumping Agreement: ",
			"p2": "Safeguards Agreement ",
			"p3": "Subsidies and Countervailing Measures Agreement",
			"p4": "WTO Dispute Settlement "
		},
		"antidumping": {
			"h1": "ANTIDUMPING IN MEXICO",
			"p1": "Foreign Trade Law",
			"p2": "Foreign Trade Law Regulations",
			"p3": "Federal Official Gazette (Diario Oficial de la Federación) ",
			"p4": "Unit of International Commercial Trade Practices (UPCI)",
			"p5": "Consultative Council of International Trade Practices (CCPCI)"
		},
		"antidumpigEUA": {
			"h1": "ANTIDUMPING IN THE US",
			"p1": "US Department of Commerce (USDOC) ",
			"p2": "International Trade Commission (USITC)",
			"p3": "Federal Register"
		},
		"estadistica": {
			"h1": "TRADE STATISTICS",
			"p1": "Tariff of General Tax Imports and Exports  Law (TIGIE)",
			"p2": "Tariff Information System via Internet (SIAVI)",
			"p3": "International Trade Center (ITC)"
		},
		"otros": {
			"h1": "OTHER RELEVANT SITES",
			"p1": "Correlation  between TIGIE and the North American Industry Classification System (NAICS)",
			"p2": "World Trade Law "
		}
	},
	"contacto": {
		"title": "Contact",
		"direccion": "Torre Siglum Insurgentes Sur #1898",
		"oficina": "Piso 14 Despacho 1421 Col. Florida",
		"cp": "01020 CDMX, México.",
		"numero": "(55)9171-1047/52",
		"email": "trez@t-rezconsulting.com"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/Lang/Eng.json
// module id = 164
// module chunks = 0